if (!customElements.get('natunora-comparison')) {
  customElements.define('natunora-comparison', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const track = (event) => {
        if (event.type === 'auxclick' && event.button !== 1) return;
        if (!event.target.closest('[data-natunora-comparison-cta]')) return;
        try {
          if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && typeof window.clarity === 'function') {
            window.clarity('event', 'natunora_comparison_offer_click');
          }
        } catch (_) {}
      };
      for (const event of ['click', 'auxclick']) this.addEventListener(event, track, { capture: true, signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
